<template>
  <div class="">
    <my-header-view
      :title="'Crear nuevo usuario'"
      icon="mdi-account-plus-outline"
      text=""
      :bread-crumbs="breadCrums"
    />
    <v-row class="my-2">
      <v-col cols="12">
        <v-card flat class="soft_shadow">
          <v-row class="py-5">
            <v-col
              cols="12"
              md="12"
              lg="10"
              class="px-md-16 px-lg-1 offset-lg-1"
            >
              <h2 class="py-4 my_battery_blue--text"></h2>
              <p class="text-body-1 support--text">
                Por favor llena los campos que se presentan a continuacion
              </p>
              <v-col cols="12" class="py-5">
                <v-alert
                  :icon="'mdi-lightbulb-on-outline'"
                  prominent
                  text
                  color="primary"
                  dense
                >
                  Recuerda colocar credenciales seguras y que sean faciles de
                  recordar para ti y tu colaborador.
                </v-alert>
              </v-col>
            </v-col>
            <v-col
              cols="12"
              md="12"
              lg="10"
              class="px-md-16 px-lg-1 offset-lg-1"
            >
              <v-form ref="form" lazy-validation @submit.prevent="createUser">
                <v-row>
                  <v-col cols="12" sm="12" md="12" class="colForm">
                    <v-text-field
                      label="Nombre"
                      required
                      outlined
                      dense
                      background-color="white"
                      v-model="usuNombre"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      outlined
                      dense
                      type="text"
                      class="input"
                      placeholder="Usuario"
                      prepend-inner-icon="mdi-account"
                      v-model="email"
                      :rules="userRules"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      outlined
                      dense
                      :type="showPassword ? 'text' : 'password'"
                      class="input"
                      placeholder="Contraseña"
                      prepend-inner-icon="mdi-lock"
                      :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="() => (showPassword = !showPassword)"
                      v-model="password"
                      :rules="passwordRules"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-select
                      :items="grupos"
                      label="Grupo"
                      item-text="sadm_gus_nombre"
                      item-value="sadm_gus_id"
                      outlined
                      dense
                      background-color="white"
                      v-model="sadm_gus_id"
                    ></v-select>
                  </v-col>
                  <v-col v-if="sadm_gus_id === 5" cols="12" md="6">
                    <v-select
                      :items="perfilesFiltered"
                      label="Perfil"
                      item-text="sadm_sispe_nombre"
                      item-value="sadm_sispe_id"
                      outlined
                      dense
                      background-color="white"
                      v-model="sadm_sispe_id"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" class="d-flex justify-end">
                    <v-btn
                      color="primary"
                      elevation="0"
                      @click="createUser"
                      :disabled="loading"
                    >
                      <v-progress-circular
                        color="white"
                        indeterminate
                        v-if="loading"
                      ></v-progress-circular>
                      <div v-else>Crear usuario</div>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import myHeaderView from "../ui/myHeaderView";
import { mapActions, mapState } from "vuex";
export default {
  name: "CreateUsuario",
  components: {
    myHeaderView,
    /*myMenuCard,*/
  },
  data: function () {
    return {
      breadCrums: [
        {
          text: "inicio",
          disabled: false,
          url: "Home",
        },
      ],
      loadingEmployees: false,
      loading: false,
      showPassword: false,
      email: "",
      password: "",
      usuNombre: "",
      sadm_gus_id: 0,
      sadm_sispe_id: 0,
      perfilesFiltered: [],
      userRules: [
        (value) => !!value || "Ingresa el usuario",
        (value) => {
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          return emailRegex.test(value) || "Ingresa un email válido";
        },
      ],
      passwordRules: [(value) => !!value || "Ingresa la constraseña"],
    };
  },
  computed: {
    ...mapState({
      usuarios: (state) => state.usuarios.usuarios,
      loadingUsuarios: (state) => state.usuarios.loading,
      establecimientoInfo: (state) => state.config.establecimientoInfo,
      grupos: (state) => state.gruposPerfiles.grupos,
      perfiles: (state) => state.gruposPerfiles.perfiles,
    }),
  },
  watch: {
    sadm_gus_id: {
      handler(newValue) {
        this.updateFilteredPerfiles(newValue);
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions({
      findSistemaPerfiles: "gruposPerfiles/findSistemaPerfiles",
      createUsuario: "usuarios/createUsuario",
    }),
    updateFilteredPerfiles(id) {
      this.perfilesFiltered = this.perfiles.filter(
        (perfil) => perfil.sadm_gus_id === id
      );
      this.sadm_sispe_id = null;
    },
    async createUser() {
      if (!this.$refs.form.validate()) return;
      this.loading = true;
      try {
        let data = {
          usuNombre: this.usuNombre,
          usuEmail: this.email,
          usuPassword: this.password,
          gusId: this.sadm_gus_id,
          sispeId: this.sadm_sispe_id ? +this.sadm_sispe_id : null,
        };
        await this.createUsuario({ data });

        this.$store.dispatch("alerts/setMessage", {
          message: "Usuario creado exitosamente",
          type: "success",
        });
        //this.reset();
      } catch (error) {
        this.$store.dispatch("alerts/setMessage", {
          message: "A ocurrido un error al momento de crear el usuario",
          type: "error",
        });
      } finally {
        this.loading = false;
      }
    },
    reset() {
      this.email = "";
      this.password = "";
      this.$refs.form.resetValidation();
    },
  },
  mounted() {
    this.$store.dispatch("usuarios/findUsuariosCorporaciones");
    this.findSistemaPerfiles();
  },
};
</script>
<style scoped src="@/assets/css/globals.css"></style>
<style scoped></style>
